<template>
	<div style="width:90%">
		<div class="container_body">
			<header class="header_nav">
				<el-form :inline="true" class="demo-form-inline" :model="searchInfo" style="margin: 20px 0px 0px 20px;">
					<el-form-item label="用户ID" class='tiny'>
						<el-input style="width: 200px;" v-model="searchInfo.userId" placeholder="请输入用户ID"></el-input>
					</el-form-item>
				
					<el-form-item label="账号" class='tiny'>
						<el-input style="width: 200px;" v-model="searchInfo.username" placeholder="请输入用户账号"></el-input>
					</el-form-item>
					<el-form-item label="资产名称" class='tiny'>
						<el-select v-model="searchInfo.integralId" class="big" placeholder="请选择" clear>
							<el-option key="-1" label="全部" value="">全部</el-option>

							<el-option v-for="item in integralList" :key="item.id" :value="item.id" :label="item.name">
							</el-option>
						</el-select>
					</el-form-item>
					<!-- <el-form-item label="变动类型" class='tiny'>
						<el-col :span="8">
							<el-select style="width: 200px;" filterable  v-model="searchInfo.type" clearable  class="big" placeholder="请选择"
								clear>
								<el-option key="-1" label="全部" value="">全部</el-option>

								<el-option v-for="item in typeList" :key="item.id" :value="item.recordTypeKey"
									:label="item.recordTypeName">
								</el-option>
							</el-select>
						</el-col>
					</el-form-item> -->
					<el-form-item label="时间">
						<div class="block">
							<el-date-picker v-model="searchInfo.timer" value-format="yyyy-MM-dd HH:mm:ss"
								type="datetimerange" start-placeholder="开始日期" end-placeholder="结束日期"
								:default-time="['00:00:00', '23:59:59']">
							</el-date-picker>
						</div>
					</el-form-item>

					<!-- <el-form-item label="收支" class='tiny'>
						<el-select v-model="searchInfo.changeType" placeholder="请选择">
							<el-option key="0" label="支出" value="0"></el-option>
							<el-option key="1" label="收入" value="1"></el-option>
						</el-select>
					</el-form-item> -->

					<el-form-item>
						<template>
							<el-button type="primary" @click="search">查询</el-button>
							<el-button @click="empty">清空</el-button>
							<!-- <el-button type="primary" @click="downloadFile"> 导出 </el-button> -->
							<!-- <el-button type="primary" @click="editialogVisible()">新增用户
                            </el-button> -->
						</template>
					</el-form-item>
				</el-form>
			</header>
		</div>

		<div style="margin: 20px">
			<div style="font-size: 14px;display: flex;justify-content: start;align-items: center;">
				<div><span style="font-weight: bold">统计：</span></div>
				<div>
					总贡献: {{ allData.contributionTotal ? allData.contributionTotal : 0 | intToFloatfour | cutZero }}
					<!-- 总确权数量: {{ allData.total ? allData.total : 0 | intToFloatfour | cutZero }} -->
				</div>
			</div>
		</div>

		<el-table class="tables" :data="userRecordList.list" stripe style="width: 100%;"
			:header-cell-style="headClass" v-loading="loading" element-loading-text="拼命加载中"
			element-loading-spinner="el-icon-loading">
			<el-table-column prop="userId" label="用户ID" align="center" width="150" :show-overflow-tooltip="true"
				:formatter="changeNull">
			</el-table-column>
			<el-table-column prop="username" label="账号" align="center" width="150" :show-overflow-tooltip="true"
				:formatter="changeNull">
			</el-table-column>
			<!-- <el-table-column prop="nickname" label="昵称" align="center" width="150" :show-overflow-tooltip="true"
				:formatter="changeNull">
			</el-table-column> -->
			
			<el-table-column prop="integralName" label="资产名称" align="center" width="100" :formatter="changeNull">
			</el-table-column>
			<el-table-column prop="confirmationRatio" label="确权比例(%)" align="center" width="150" :formatter="changeNull">
				<template slot-scope="scope">
					{{scope.row.confirmationRatio*100}}
					
				</template>
			</el-table-column>
			<el-table-column prop="total" label="确权数量" align="center" width="150" :formatter="changeNull">
			</el-table-column>
			<el-table-column prop="contributionTotal" label="获得贡献" align="center" width="150" :formatter="changeNull">
			</el-table-column>
			
			<el-table-column label="状态" prop="status" align="center" width="100" >
				<template slot-scope="scope">
					<p v-if="scope.row.status==1">确权中</p>
					
				</template>
			</el-table-column>
			
			<el-table-column prop="changeReason" label="备注" align="center" :formatter="changeNull" :show-overflow-tooltip="true">
			</el-table-column>
		
			<el-table-column prop="createTime" label="创建时间" width="" align="center" :show-overflow-tooltip="true" >
			</el-table-column>
			<!-- <el-table-column  label="操作"  fixed="right" align="center">
                　　　　<template slot-scope="scope">
                    　　　　　　<el-button size="small" type="text" @click="toDelete(scope.row.id)">删除</el-button>
                    　　　　　　<el-button size="small" type="text" @click="dialogVisibleFun(scope.row.id)">拨币</el-button>
                    　　　　</template>
                　　</el-table-column> -->
		</el-table>
		<div style="display: flex;align-items: center;justify-content: space-between;">
			<el-pagination style="margin: 20px;" background :current-page="userRecordList.pageNum"
				@current-change="pageChange" @size-change="handleSizeChange"
				layout="total, sizes, prev, pager, next, jumper" :total="userRecordList.total">
			</el-pagination>
		</div>

	</div>
</template>

<script>
	export default {
		data() {
			return {
				loading: false,
				userRecordList: {}, //用户列表
				dialogVisible: false,
				typeList: [],
				integralList: [],
				integralId: "", //积分id
				page: {
					pageNum: 1,
					pageSize: 10
				},
				searchInfo: {
					integralId: '',
					type: '',
					timer:this.timelist()
				},
				allData: {}
			};
		},
		filters: {
			intToFloatfour(val) {
				return (Math.floor(Number(val) * 10000) / 10000).toFixed(4)
			},
			cutZero(old) {
				//拷贝一份 返回去掉零的新串
				old = old + ""
				var newstr = old
				//循环变量 小数部分长度
				var i = 0
				var leng = old.length - old.indexOf(".") - 1
				//判断是否有效数
				if (old.indexOf(".") > -1) {
					//循环小数部分
					for (i = leng; i > 0; i--) {
						//如果newstr末尾有0
						if (newstr.lastIndexOf("0") > -1 && newstr.substr(newstr.length - 1, 1) == 0) {
							var k = newstr.lastIndexOf("0")
							//如果小数点后只有一个0 去掉小数点
							if (newstr.charAt(k - 1) == ".") {
								return newstr.substring(0, k - 1)
							} else {
								//否则 去掉一个0
								newstr = newstr.substring(0, k)
							}
						} else {
							//如果末尾没有0
							return newstr
						}
					}
				}
				return old
			}

		},
		methods: {
			timelist(){
				var arr=[]
				var date = new Date();
				   //年 getFullYear()：四位数字返回年份
				   var year = date.getFullYear();  //getFullYear()代替getYear()
				   //月 getMonth()：0 ~ 11
				   var month = date.getMonth() + 1;
				   //日 getDate()：(1 ~ 31)
				   var day = date.getDate();
				   //时 getHours()：(0 ~ 23)
				   var hour = date.getHours();
				   //分 getMinutes()： (0 ~ 59)
				   var minute = date.getMinutes();
				   //秒 getSeconds()：(0 ~ 59)
				   var second = date.getSeconds();
								
				   var time =+ year + '-' + month + '-' + day + ' ' + '00:00:00';
									var time1 =+ year + '-' + month + '-' + day + ' ' + '23:59:59';
									console.log(time1);
									arr.unshift(time1)
									arr.unshift(time)
									return arr
			},
			//导出
			downloadFile() {
				let data = {
					startTime: this.searchInfo.timer ? this.searchInfo.timer[0] : time,
					endTime: this.searchInfo.timer ? this.searchInfo.timer[1] : time1,
					username: this.searchInfo.username, 
					userId: this.searchInfo.userId,
					phone: this.searchInfo.phone,
					integralId: this.searchInfo.integralId,
					source: this.searchInfo.type
				};
				//   console.log(data);				
				if (data.startTime || data.endTime) {
					this.$api.assetChangesExcel(data).then((res) => {
					console.log(res.data);
					this.showloadFile(res.data);
				});
				} else {
					this.$message.error('请选择时间')
				}
			},
			showloadFile(res) {
				if (!res) {
					return;
				}
				const link = document.createElement("a");
				let blob = new Blob([res], {
					type: "application/vnd.ms-excel",
				});
				link.style.display = "none";
				link.href = URL.createObjectURL(blob);
				link.setAttribute("download", "资产变动记录" + ".xls");
				document.body.appendChild(link);
				link.click();
				URL.revokeObjectURL(link.href); // 释放URL 对象
				document.body.removeChild(link);
			},
			changeNull(row, column, cellValue) {
				if (cellValue) {
					return cellValue;
				} else if (cellValue == 0) {
					return "0";
				} else {
					return "暂无";
				}
			},
			empty() {
				this.searchInfo = {}
			},
			search() {
				this.page.pageNum = 1;
				this.getUserRecordList();
			},
			headClass() {
				return 'text-align:center;background:#E6E9F0;color: rgb(31, 46, 77);height:56px'
			},
			pageChange(data) {
				this.page.pageNum = data
				this.getUserRecordList()
			},
			handleSizeChange(val) {
				this.page.pageSize = val
				this.getUserRecordList()
			},
			
			getUserRecordList() {
				this.loading = true
				 var date = new Date();
				    //年 getFullYear()：四位数字返回年份
				    var year = date.getFullYear();  //getFullYear()代替getYear()
				    //月 getMonth()：0 ~ 11
				    var month = date.getMonth() + 1;
				    //日 getDate()：(1 ~ 31)
				    var day = date.getDate();
				    //时 getHours()：(0 ~ 23)
				    var hour = date.getHours();
				    //分 getMinutes()： (0 ~ 59)
				    var minute = date.getMinutes();
				    //秒 getSeconds()：(0 ~ 59)
				    var second = date.getSeconds();
				
				    var time =+ year + '-' + month + '-' + day + ' ' + '00:00:00';
					var time1 =+ year + '-' + month + '-' + day + ' ' + '23:59:59';
					console.log(time1);
				let data = {
					pageNum: this.page.pageNum,
					pageSize: this.page.pageSize,

					startTime: this.searchInfo.timer ? this.searchInfo.timer[0] : '',
					endTime: this.searchInfo.timer ? this.searchInfo.timer[1] : '',
					username: this.searchInfo.username,
					userId: this.searchInfo.userId,
					phone: this.searchInfo.phone,
					integralId: this.searchInfo.integralId,
					source: this.searchInfo.type
				}
				this.$api.confirmationRightsList(data).then((res) => {
					// res=JSON.parse(this.$decrypt(res.data))
					console.log('六十六大神了--', res)
					if (res.state == 'success') {
						this.userRecordList = res.data
						this.loading = false
					} else {
						this.$message.error(res.message)
					}
				})
				this.$api.findSumconfirmationRights(data).then((res) => {
					// res=JSON.parse(this.$decrypt(res.data))
					if (res.state == 'success') {
						this.allData = res.data
					}
				})
			},
		
		},
		created() {
			// console.log(this.timelist());
			this.getUserRecordList();
			this.$api.getIntegralListTwo().then((res) => {
				// res=JSON.parse(this.$decrypt(res.data))
				if (res.state == 'success') {
					this.integralList = res.data
				}
			})
		}
	};
</script>

<style>
	.demo-table-expand {
		font-size: 0;
		margin-left: 30px;
	}

	.demo-table-expand label {
		width: 100px;
		color: #99a9bf;
	}

	.demo-table-expand .el-form-item {
		margin-right: 0;
		margin-bottom: 0;
		width: 50%;
	}
</style>
